
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15002.65 16848.35 13.301 13.301"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_204_22","data-name":"Symbol 204 – 22","transform":"translate(1670 222)","opacity":".64"}},[_c('g',{attrs:{"id":"Group_8330","data-name":"Group 8330"}},[_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_952","cx":"6","cy":"6","r":"6","data-name":"Ellipse 952","transform":"translate(-16672 16627)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3655","d":"M5.1 5.418l1.818 1.909L9.373 4.6","data-name":"Path 3655","transform":"translate(-16673.01 16626.037)"}}),_c('circle',{attrs:{"id":"Ellipse_953","cx":".909","cy":".909","r":".909","data-name":"Ellipse 953","transform":"translate(-16667 16632.363)","fill":"#444"}})])])])
          )
        }
      }
    